import { EMPTY_ARR } from '../../../../../../constants';
import { AccordionRadioGroup } from '../../../../../../types';

export const getSelectedOptionFromGroupOptions = (
  value: string | number,
  options: AccordionRadioGroup['options'] = EMPTY_ARR,
) => options.find((option) => option.value === value);
